

import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import ToyotaLogo from '../../../../static/images/TO/toyota-logo.svg';
import MissingPhoneForm from './MissingPhoneForm';
import MissingEmailForm from './MissingEmailForm';
import returnHeader from "../Register/RegisterHeaders";
import Loader from '../../../Loader';
import AppVars from '../../../../AppVars.js';


const INPUT_VALIDATION = {
    "PHONE" : "^(?!0)[0-9]{10}$"
}

const appVars = AppVars.getInstance();

class MissingEmailAndPhoneView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
    

        }
    }

    render (){
            return(
                <div>
                <div className = "justify-content-center email-phone-line-box">
                    <Row className = "">
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                    <div
                        id = "missingFieldsSubmissionError"
                        data-testid = "missingFieldsSubmissionError"  
                        className = {`${this.props.isResponseValid === false ? "error-modal" : "none"}`} 
                        role = "alert"
                        aria-hidden = {`${this.props.isResponseValid === false ? "false" : "true"}`}>
                    <div className = "error-modal-text">
                    The service is down. Please try again shortly.
                    </div>
                    <span onClick={this.props.hideModal} className = "modal-close">&times;</span>
                    </div>
                    <div>
                        {returnHeader("FINISH-SOCIAL", this.props.provider, this.props.style)}
                    </div>
                    <Form id = "missing2FieldsForm" noValidate validated = {this.props.isEmailValid && this.props.isPhoneValid} onSubmit={this.props.handleMissingFieldsFormSubmit}>
                    {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
                    <MissingEmailForm 
                        mail={this.props.mail} 
                        handleEmailChange={this.props.handleEmailChange} 
                        isEmailValid={this.props.isEmailValid} 
                        isEmailAvailable={this.props.isEmailAvailable}
                        setFocusEmail = {this.props.setFocusEmail}
                        removeFocusEmail = {this.props.removeFocusEmail}
                        emailFocus = {this.props.emailFocus}
                        onBlurEmail = {this.props.onBlurEmail}
                        floatEmail = {this.props.floatEmail}
                        />
                    <MissingPhoneForm
                        emailIsMissing={true} 
                        phone={this.props.telephoneNumber} 
                        handlePhoneChange={this.props.handlePhoneChange} 
                        isPhoneValid={this.props.isPhoneValid} 
                        isPhoneAvailable={this.props.isPhoneAvailable}
                        setFocusPhone = {this.props.setFocusPhone}
                        removeFocusPhone = {this.props.removeFocusPhone}
                        phoneFocus = {this.props.phoneFocus}
                        onBlurPhone = {this.props.onBlurPhone}
                        floatPhone = {this.props.floatPhone}
                        />

                    <div className="required required-left-grid"><span><span id="redStar">*</span>Required</span></div>
                    <div className = "button-right">
                        <Button data-testid = "createPasswordButton" bsPrefix = {`${(this.props.isEmailValid && this.props.isPhoneValid) !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Submit</Button>
                    </div>
                    </Form>
                </div>
                </div>
            )
        }
    }


export default MissingEmailAndPhoneView;